module.exports = __webpack_public_path__ + "static/media/Paleta nova - Utopia.6a792e71.glb";